import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { KeyRound, ArrowRight } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/parent/password/reset", { token, new_password: pw });
      toast.success("Password updated — please sign in.");
      navigate("/signin");
    } catch (err) { toast.error(err?.response?.data?.detail || "Reset failed"); }
    finally { setBusy(false); }
  };

  if (!token) {
    return (
      <div className="max-w-md mx-auto px-5 py-24 text-center">
        <h1 className="font-display font-black text-3xl">Missing reset link</h1>
        <p className="mt-3 text-[#7A7D8C]">The link you used isn't valid. <Link to="/forgot-password" className="text-[#FF9F1C] font-semibold">Request a new one</Link>.</p>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto px-5 py-16 md:py-24">
      <div className="w-14 h-14 rounded-2xl bg-[#FFBF69]/25 grid place-items-center text-[#B36906]"><KeyRound className="w-6 h-6" /></div>
      <h1 className="mt-6 font-display font-black text-4xl tracking-tight">Choose a new password</h1>
      <p className="mt-3 text-[#7A7D8C]">Pick something 8+ characters that you can remember.</p>

      <form onSubmit={submit} className="mt-8 bg-white rounded-3xl border border-slate-100 p-6 space-y-4" data-testid="reset-form">
        <div>
          <label className="text-xs uppercase tracking-wider font-semibold text-[#7A7D8C]">New password</label>
          <input data-testid="reset-password" type="password" value={pw} required onChange={(e) => setPw(e.target.value)} className="mt-1 w-full rounded-xl border border-slate-200 bg-[#FDFFFC] px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF9F1C]" />
        </div>
        <button disabled={busy} type="submit" data-testid="reset-submit" className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-[#FF9F1C] text-white font-bold shadow-[0_12px_30px_rgb(255,159,28,0.35)] disabled:opacity-60">
          {busy ? "Saving…" : "Save password"} <ArrowRight className="w-4 h-4" />
        </button>
      </form>
    </div>
  );
}
